import React from "react";
import { Box, Stack, Typography, Avatar } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useCachedAvatar } from "../../hooks/useCachedAvatar";

/**
 * WriterInfoCard
 * @param {object} props
 * @param {object} props.user - user doc minimal (expects id or profile.id)
 * @param {boolean} [props.isMobile]
 * @param {string|null} [props.fallbackAvatarUrl] - 폴백 아바타 URL
 */
const WriterInfoCard = ({ user, isMobile, fallbackAvatarUrl = null }) => {
	const theme = useTheme();
	const username = user?.profile?.username || user?.profile?.name || "";
	const userId = String(user?.id || user?.user_id || user?.profile?.id || "");

	// Avatar System: useCachedAvatar (public URL + progressive cache), with fallback
	const { imageSrc } = useCachedAvatar(userId, fallbackAvatarUrl, 160);

	const avatarSize = isMobile ? 56 : 80; // 전반적인 사이즈 업

	const displayName = user?.profile?.name || "";

	return (
		<Box sx={{ width: "100%", p: isMobile ? 1.5 : 2.5, overflow: 'hidden' }}>
			<Stack direction="column" spacing={1} alignItems="center" sx={{ width: '100%', overflow: 'hidden' }}>
				<Avatar
					src={imageSrc || undefined}
					sx={{ width: avatarSize, height: avatarSize }}
				>
					{username ? username.charAt(0).toUpperCase() : "?"}
				</Avatar>
				<Stack direction="column" spacing={0} alignItems="center" sx={{ width: "100%", overflow: 'hidden' }}>
					<Typography
						variant={isMobile ? "body2" : "body1"}
						color={theme.palette.text.primary}
						sx={{ 
							textAlign: "center", 
							width: "100%", 
							fontWeight: 800,
							overflow: "hidden",
							textOverflow: "ellipsis",
							whiteSpace: "nowrap"
						}}
					>
						{displayName}
					</Typography>
					<Typography
						color={theme.palette.text.secondary}
						variant={isMobile ? "body2" : "body2"}
						sx={{ 
							textAlign: "center", 
							width: "100%",
							overflow: "hidden",
							textOverflow: "ellipsis",
							whiteSpace: "nowrap"
						}}
					>
						@{username}
					</Typography>
				</Stack>
			</Stack>
		</Box>
	);
};

export default WriterInfoCard;
